import { render, staticRenderFns } from "./CatalogSwitch.vue?vue&type=template&id=707036d4&scoped=true&"
import script from "./CatalogSwitch.vue?vue&type=script&lang=js&"
export * from "./CatalogSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSwitch.vue?vue&type=style&index=0&id=707036d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707036d4",
  null
  
)

export default component.exports